
export const getQueryParamsFromPath = (path) => {
  try {
    const url = new URL(path, window.location.origin);
    return {
      ...Object.fromEntries(
        typeof window === "undefined" ? {} : url.searchParams.entries()
      ),
    };
  } catch (e) {
    console.warn(e);
  }
  return {};
};
